import { ReactComponentManifest } from "web/entrypoints/common/setup";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import ToAppPage from "web/react/pages/app/to-app-page";
import AppDownloadTeaserImage from "web/react/components/app-download-teaser-image/app-download-teaser-image";
import BannerContainer from "web/react/components/banner-container/banner-container";
import Breadcrumbs from "web/react/components/breadcrumbs/breadcrumbs";
import CustomerCaptureOverlay from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import CookieSettingsContainer from "web/react/components/cookie-settings-container/cookie-settings-container";
import Example from "web/react/components/example/example";
import JSONLDOrganization from "web/react/components/json-ld/json-ld-organization";
import MainNavigation from "web/react/components/main-navigation/main-navigation";
import MainNavigationToggleMobile from "web/react/components/main-navigation/main-navigation-toggle-mobile/main-navigation-toggle-mobile";
import CartSummary from "web/react/components/app-header/cart-summary/cart-summary";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsShowMore from "web/react/components/related-products-show-more/related-products-show-more";
import SearchButton from "web/react/components/search-button/search-button";
import Tooltip from "web/react/components/tooltip/tooltip";
import TopBanner from "web/react/components/top-banner/top-banner";
import withRedux from "web/react/redux-provider";
import CookieConsentModal from "web/react/components/cookie-consent-modal/cookie-consent-modal";
import SearchNoResults from "web/react/components/search-no-results/search-no-results";
import ScrollToTopButton from "web/react/components/scroll-to-top-button/scroll-to-top-button";

/*
    Common components that are on every page (eg header)
*/
const components: ReactComponentManifest = {
    AppDownloadBadge,
    ToAppPage,
    AppDownloadTeaserImage,
    BannerContainer: withRedux(BannerContainer),
    Breadcrumbs,
    CookieConsentModal: withRedux(CookieConsentModal),
    CookieSettingsContainer,
    CustomerCaptureOverlay,
    Example,
    JSONLDOrganization,
    MainNavigation,
    MainNavigationToggleMobile,
    CartSummary,
    RecentlyViewedEmailCapture,
    RelatedProductsShowMore,
    SearchButton,
    SearchNoResults,
    ScrollToTopButton,
    Tooltip,
    TopBanner,
};

export default components;
